import { Component, OnInit } from '@angular/core';
import { TransferHttpService } from '../../../../../services/transfer-http/transfer-http.service';
import { PermissionsService } from '../../../../../services/permissions/permissions.service';
import { ViewObservationsBaseComponent } from '../view-observations-base/view-observations-base.component';
import { GetTextPipe } from 'src/app/pipes';

@Component({
  selector: 'view-not-valid-cars',
  templateUrl: '../viewObservations.component.html',
  styleUrls: ['./view-not-valid-cars.component.css'],
  providers: [GetTextPipe]
})
export class ViewNotValidCarsComponent extends ViewObservationsBaseComponent implements OnInit {

  constructor(public transferHttp: TransferHttpService,
    public getTextPipe: GetTextPipe,
    public permissions: PermissionsService) {
      super(transferHttp, getTextPipe);
  }

  //***************************
  // Variables
  //***************************

  pageHeader: string = "View Not Valid CARs";

  printReportName: string = null;

  //***************************
  // Functions
  //***************************

  //***************************
  // Init
  //***************************

  ngOnInit(): void {
    super.setFlags(true, false);
    this.excelReportName = null;
    this.observations = this.transferHttp.getSingle('QualityControl/ViewNotValidCARs');
  }

}
